import React from 'react';
import Benefits from '../../data/Benefits';
import LottieCard from './_shared/LottieCard';
import SelectionCard from './_shared/SelectionCard';
import SelectionProvider from '../../contexts/SelectionContext';

const BenefitsCards = () => {
    return (
        <div className="flex flex-col lg:flex-row lg:space-x-5">
            <SelectionProvider selectionList={Benefits}>
                <SelectionCard title="4 key FanCollex® benefits​​" />

                <LottieCard />
            </SelectionProvider>
        </div>
    );
};

export default BenefitsCards;
